export const toSnakeCase = (str: string): string => {
  if (!str) return '';
  return str
    .replace(/([A-Z])/g, (letter) => `_${letter.toLowerCase()}`)
    .replace(/^_/, '')
    .replace(/\s+/g, '_')
    .toLowerCase();
};
